import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {NameCandidate, NameMention} from '../../../../../../../api';
import {ElciaButton} from '../../../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-ai-name-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ElciaButton],
  templateUrl: './ai-name-picker.html',
  styleUrl: './ai-name-picker.scss',
})
export class AiNamePicker {

  readonly mention = input.required<NameMention>();

  readonly chosen = output<NameCandidate>();
}
